import api from 'Api'

export class PaymentService {
  async addNewCard(businessProfileId, isLiveMode, region) {
    try {
      var response = await api.post(`/businessProfiles/${businessProfileId}/stripe/paymentOptions`, {
        isLiveMode,
        region
      });
      return response.data.data;
    }
    catch (error) {
      throw error;
    }
  }
  async getPaymentOptions(businessProfileId) {
    try {
      var response = await api.get(`/businessProfiles/${businessProfileId}/stripe/paymentOptions`);
      return response.data;
    }
    catch (error) {
      throw error;
    }
  }
  async deleteCard(businessProfileId, id) {
    try {
      await api.delete(`/businessProfiles/${businessProfileId}/stripe/paymentOptions`, {
        data: {
          id
        }
      });
    }
    catch (error) {
      throw error
    }
  }
  async changeDefaultCard(businessProfileId, id) {
    try {
      await api.post(`/businessProfiles/${businessProfileId}/stripe/cards/default`, {
        id
      });
    }
    catch (error) {
      throw error
    }
  }
  async addFunds(businessProfileId, amount, paymentOptionId, paymentIntentId, user) {
    try {
      await api.post(`/businessProfiles/${businessProfileId}/payment/wallet`, {
        amount,
        paymentOptionId,
        paymentIntentId,
        walletAction: 1,
        user
      });
    }
    catch (error) {
      throw error
    }
  }
  async createPaymentIntent(businessProfileId, transferFundRequest) {
    var response = await api.post(`/businessProfiles/${businessProfileId}/stripe/paymentIntent`, transferFundRequest);
    return response.data.data;
  }
  async getWallet(businessProfileId) {
    try {
      var response = await api.get(`/businessProfiles/${businessProfileId}/payment/wallet`);
      return response.data;
    }
    catch (error) {
      throw error
    }
  }
  async refund(businessProfileId, amount, paymentOptionId, idempotencyKey) {
    try {
      await api.post(`/businessProfiles/${businessProfileId}/payment/wallet`, {
        amount,
        paymentOptionId,
        idempotencyKey,
        walletAction: 2
      });
    }
    catch (error) {
      throw error
    }
  }
  async getTransactions(businessProfileId, limit, page) {
    try {
      var response = await api.get(`/businessProfiles/${businessProfileId}/payment/wallet/transactions`, { params: { limit, page } });
      return response.data.data;
    }
    catch (error) {
      throw error;
    }
  }
  async getCountryPaymentGateway(businessProfileId, region) {
    var response = await api.get(`/businessProfiles/${businessProfileId}/payment/PaymentGateway`, { params: { region } });
    return response.data;
  }
  async createRazorpayOrder({ businessProfileId, amount, currency, receipt, isLiveMode }) {
    var response = await api.post(`/businessProfiles/${businessProfileId}/payment/razorpay/order`, {
      amount,
      currency,
      receipt,
      partialPayment: false,
      isLiveMode
    });
    return response.data.data;
  }
  async verifyRazorpayPayment(businessProfileId, payload) {
    var response = await api.post(`/businessProfiles/${businessProfileId}/payment/razorpay/verify`, payload);
    return response.data.data;
  }
  async getCountryPaymentGatewayForSession(sessionId, region, portalDomain) {
    var response = await api.get(`/localbusiness/${sessionId}/payment/PaymentGateway`, { params: { region, portalDomain } });
    return response.data;
  }
  async createRazorpayOrderForSession({ sessionId, amount, currency, receipt, isLiveMode }, region) {
    var response = await api.post(`/localbusiness/${sessionId}/payment/razorpay/order`, {
      amount,
      currency,
      receipt,
      partialPayment: false,
      isLiveMode
    }, { params: { region } });
    return response.data.data;
  }
  async verifyRazorpayPaymentForSession(sessionId, payload) {
    var response = await api.post(`/localbusiness/${sessionId}/payment/razorpay/verify`, payload);
    return response.data.data;
  }
  async createPaymentIntentForSession(sessionId, transferFundRequest, region) {
    var response = await api.post(`/localbusiness/${sessionId}/stripe/paymentIntent`, transferFundRequest,  { params: { region } });
    return response.data.data;
  }
  async getPaymentOptionsForSession() {
    try {
      var response = await api.get('/localbusiness/stripe/paymentOptions', { params: { isForSession: true } });
      return response.data;
    }
    catch (error) {
      throw error;
    }
  }
}